import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import './index.css'
import { QueryProvider } from 'app/providers/QueryProvider'
import { GlobalErrorBoundary } from 'app/providers/GlobalErrorBoundary'
import { router } from 'app/router'
import { installDevWebviewTokenBridge } from 'shared/lib/devWebviewTokenBridge'
import { lockWebviewLayout } from 'shared/lib/lockWebviewLayout'

lockWebviewLayout()

if (import.meta.env.DEV && import.meta.env.VITE_DEV_WEBVIEW_TOKEN?.trim()) {
  installDevWebviewTokenBridge(import.meta.env.VITE_DEV_WEBVIEW_TOKEN, {
    channelDelayMs: Number(import.meta.env.VITE_DEV_WEBVIEW_CHANNEL_DELAY_MS),
    tokenDelayMs: Number(import.meta.env.VITE_DEV_WEBVIEW_TOKEN_DELAY_MS),
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <QueryProvider>
        <RouterProvider router={router} />
      </QueryProvider>
    </GlobalErrorBoundary>
  </StrictMode>
)
